import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

type AlertDialogProps = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  setIsReturn?: (value: boolean) => void; // 확인 버튼을 눌렀을 때 실행 요청
  title: string;
  content: string;
  cancel?: string;
  agree?: string;
  cancelUrl?: string;
};

export default function SendAlert(aPayload: AlertDialogProps) {
  const { isOpen, setIsOpen, setIsReturn, title, content, cancel = '취소', agree = '확인', cancelUrl } = aPayload;
  const navigate = useNavigate();
  const handleClose = () => {
    if (setIsReturn !== undefined) {
      setIsReturn(false);
    }
    setIsOpen(false);
    // window.location.reload();
    // if (setIsReturn !== undefined) {
    //   setIsReturn(false);
    // }
    // setIsOpen(false);
  };
  const handleSubmit = () => {
    if (setIsReturn !== undefined) {
      setIsReturn(true);
    }
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      Swal.fire({
        icon: 'info',
        title: title,
        text: `${content}`,
        showCancelButton: true,
        cancelButtonText: cancel,
        confirmButtonText: agree,
      }).then((res) => {
        /* Read more about isConfirmed, isDenied below */
        if (res.isConfirmed) {
          //삭제 요청 처리
          handleSubmit();
        } else {
          //취소
          handleClose();
        }
      });
    }

    return () => {};
  }, [isOpen]);

  return <></>;
}
